// import { createAsyncThunk } from '@reduxjs/toolkit'
// import { toast } from 'react-hot-toast'
// import {
//   getPatientsAPI,
//   createPatientAPI,
//   editPatientAPI,
//   deletePatientAPI,
//   getSinglePatient,
//   getAssigneesAPI,
//   assignPatientAPI,
//   getAssignedPatientsAPI
// } from './api'

// // ============================================================
// // FETCH ALL PATIENTS - ✅ FIXED: Proper pagination handling
// // ============================================================
// export const getPatients = createAsyncThunk(
//   'Patient/getPatients',
//   async (params = {}, { rejectWithValue }) => {
//     try {
//       console.log('🔄 FETCH PATIENTS:', {
//         page: params.page || 1,
//         pageSize: params.pageSize || 10,
//         search: params.search || 'none',
//         status: params.status || 'all',
//       });

//       const res = await getPatientsAPI(params);
      
//       console.log('✅ API Response:', {
//         docsCount: res.data.documents?.length || 0,
//         total: res.data.total,
//         currentPage: res.data.currentPage,
//         totalPages: res.data.totalPages,
//       });

//       // ✅ Ensure we always return the correct structure
//       return {
//         documents: res.data.documents || [],
//         total: res.data.total || 0,
//         currentPage: res.data.currentPage || 1,
//         totalPages: res.data.totalPages || 0,
//       };
//     } catch (error) {
//       const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch patients';
//       console.error('❌ FETCH PATIENTS ERROR:', errorMessage);
//       toast.error(errorMessage);
//       return rejectWithValue(errorMessage);
//     }
//   }
// );

// //Fetch SIngle Patient
// export const getPatient = createAsyncThunk('SinglePatient/getPatient', async payload => {
//   const res = await getSinglePatient(payload)
//   return res
// })

// // Create a new patient
// export const createPatient = createAsyncThunk('Patient/createPatient', async payload => {
//   const resultPromise = new Promise((resolve, reject) => {
//     createPatientAPI(payload)
//       .then(res => {
//         resolve(res)
//       })
//       .catch(({ response }) => {
//         reject(response?.data?.message || response?.data?.error || 'Something went wrong')
//       })
//   })

//   toast.promise(resultPromise, {
//     loading: 'Creating patient...',
//     success: 'Patient created successfully',
//     error: err => err
//   })

//   return await resultPromise
// })

// // Edit an existing patient

// export const editPatient = createAsyncThunk('Patient/editPatient', async ({ id, data }, { rejectWithValue }) => {
//   console.log('Payload being sent for editing:', { id, data }) // Log the payload

//   try {
//     const response = await editPatientAPI(id, data)
//     toast.success('Patient updated successfully')
//     return response.patient // Ensure the correct data is returned
//   } catch (error) {
//     const errorMessage = error.response?.data?.error || 'Something went wrong'
//     toast.error(errorMessage)
//     return rejectWithValue(errorMessage)
//   }
// })

// // Delete a patient
// export const deletePatient = createAsyncThunk('Patient/deletePatient', async (id, { dispatch }) => {
//   const resultPromise = new Promise((resolve, reject) => {
//     console.log('Attempting to delete patient with ID:', id)

//     deletePatientAPI(id)
//       .then(res => {
//         resolve(res)
//       })
//       .catch(({ response }) => {
//         if (response?.status === 404) {
//           reject('Patient not found')
//         } else {
//           reject(response?.data?.error || 'Something went wrong')
//         }
//       })
//   })

//   toast.promise(resultPromise, {
//     loading: 'Deleting patient...',
//     success: 'Patient deleted successfully',
//     error: err => err
//   })

//   await resultPromise

//   // Dispatch getPatients to refresh the list of patients after deletion
//   dispatch(getAssignedPatients())

//   return id // Optionally return the deleted patient ID
// })

// // Get Assignees
// export const getAssignees = createAsyncThunk('Assignee/getAssignee', async () => {
//   const res = await getAssigneesAPI()
//   return res.users
// })

// // ============================================================
// // ASSIGN PATIENT - ✅ Complete fix with proper payload
// // ============================================================
// export const assignPatient = createAsyncThunk(
//   'Patient/assignPatient',
//   async ({ id, assigneeId }, { dispatch, rejectWithValue }) => {
//     try {
//       console.log('🚀 ASSIGN START:', { patientId: id, assigneeId });
      
//       // Call API with proper payload
//       const response = await assignPatientAPI({ _id: id }, { _id: assigneeId });
//       console.log('📬 API Response:', response);
      
//       // ✅ Extract patient from response - handle different response structures
//       const updatedPatient = response?.patient || response?.data?.patient || response;
      
//       if (!updatedPatient || !updatedPatient._id) {
//         console.error('❌ No valid patient data in response:', response);
//         throw new Error('Invalid response from server');
//       }
      
//       console.log('✅ Extracted patient:', updatedPatient);
      
//       // ✅ Refresh assigned patients list in background
//       console.log('🔄 Refreshing assigned patients list...');
//       dispatch(getAssignedPatients());
      
//       // Return the updated patient for state update
//       return updatedPatient;
      
//     } catch (error) {
//       console.error('❌ ASSIGN FAILED:', {
//         error: error.message,
//         response: error.response?.data,
//         status: error.response?.status
//       });
      
//       const errorMessage = error.response?.data?.message || error.message || 'Failed to assign patient';
//       return rejectWithValue(errorMessage);
//     }
//   }
// );

// // ============================================================
// // GET ASSIGNED PATIENTS
// // ============================================================
// export const getAssignedPatients = createAsyncThunk(
//   'Patient/getAssignedPatients',
//   async (_, { rejectWithValue }) => {
//     try {
//       console.log('🔄 FETCH START: Loading assigned patients...');
      
//       const res = await getAssignedPatientsAPI();
//       console.log('📡 API Response received:', res);
      
//       // ✅ Extract and validate patients array
//       const patients = Array.isArray(res.data.patients) 
//         ? res.data.patients 
//         : [];
      
//       console.log('✅ FETCH SUCCESS:', {
//         count: patients.length,
//         patients: patients.map(p => ({
//           id: p._id,
//           name: `${p.firstName} ${p.lastName}`,
//           assignee: p.assignee
//         }))
//       });
      
//       return patients;
      
//     } catch (error) {
//       const errorDetails = {
//         message: error.response?.data?.message || error.message,
//         status: error.response?.status,
//         statusText: error.response?.statusText,
//         endpoint: '/patient/assigned',
//         responseData: error.response?.data
//       };
      
//       console.error('❌ FETCH FAILED: Error loading assigned patients:', errorDetails);
      
//       const errorMessage = error.response?.data?.message || 'Failed to fetch assigned patients';
      
//       return rejectWithValue(errorMessage);
//     }
//   }
// );

import { createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-hot-toast'
import {
  getPatientsAPI,
  createPatientAPI,
  editPatientAPI,
  deletePatientAPI,
  getSinglePatient,
  getAssigneesAPI,
  assignPatientAPI,
  getAssignedPatientsAPI
} from './api'

// ============================================================
// FETCH ALL PATIENTS
// ============================================================
export const getPatients = createAsyncThunk(
  'Patient/getPatients',
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await getPatientsAPI(params);

      return {
        documents: res.data.documents || [],
        total: res.data.total || 0,
        currentPage: res.data.currentPage || 1,
        totalPages: res.data.totalPages || 0,
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch patients';
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// Fetch Single Patient
export const getPatient = createAsyncThunk('SinglePatient/getPatient', async payload => {
  const res = await getSinglePatient(payload)
  return res
})

// Create a new patient
export const createPatient = createAsyncThunk('Patient/createPatient', async payload => {
  const resultPromise = new Promise((resolve, reject) => {
    createPatientAPI(payload)
      .then(res => {
        resolve(res)
      })
      .catch(({ response }) => {
        reject(response?.data?.message || response?.data?.error || 'Something went wrong')
      })
  })

  toast.promise(resultPromise, {
    loading: 'Creating patient...',
    success: 'Patient created successfully',
    error: err => err
  })

  return await resultPromise
})

// Edit an existing patient
export const editPatient = createAsyncThunk('Patient/editPatient', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await editPatientAPI(id, data)
    toast.success('Patient updated successfully')
    return response.patient
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Something went wrong'
    toast.error(errorMessage)
    return rejectWithValue(errorMessage)
  }
})

// Delete a patient
export const deletePatient = createAsyncThunk('Patient/deletePatient', async (id, { dispatch }) => {
  const resultPromise = new Promise((resolve, reject) => {
    deletePatientAPI(id)
      .then(res => {
        resolve(res)
      })
      .catch(({ response }) => {
        if (response?.status === 404) {
          reject('Patient not found')
        } else {
          reject(response?.data?.error || 'Something went wrong')
        }
      })
  })

  toast.promise(resultPromise, {
    loading: 'Deleting patient...',
    success: 'Patient deleted successfully',
    error: err => err
  })

  await resultPromise

  dispatch(getAssignedPatients())

  return id
})

// Get Assignees
export const getAssignees = createAsyncThunk('Assignee/getAssignee', async () => {
  const res = await getAssigneesAPI()
  return res.users
})

// ============================================================
// ASSIGN PATIENT
// ============================================================
export const assignPatient = createAsyncThunk(
  'Patient/assignPatient',
  async ({ id, assigneeId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await assignPatientAPI({ _id: id }, { _id: assigneeId });

      const updatedPatient = response?.patient || response?.data?.patient || response;

      if (!updatedPatient || !updatedPatient._id) {
        throw new Error('Invalid response from server');
      }

      dispatch(getAssignedPatients());

      return updatedPatient;

    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to assign patient';
      return rejectWithValue(errorMessage);
    }
  }
);

// ============================================================
// GET ASSIGNED PATIENTS
// ============================================================
export const getAssignedPatients = createAsyncThunk(
  'Patient/getAssignedPatients',
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAssignedPatientsAPI();

      const patients = Array.isArray(res.data.patients)
        ? res.data.patients
        : [];

      return patients;

    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch assigned patients';
      return rejectWithValue(errorMessage);
    }
  }
);